<template>
    <div v-if="hasUsers">
        <div class="relative inline-block text-left" v-click-outside="closeExportMenu">
            <button
                type="button"
                class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                @click="showExportMenu = !showExportMenu"
            >
                Export
                <i class="fa fa-chevron-down ml-2 text-xs"></i>
            </button>

            <div
                v-if="showExportMenu"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10"
            >
                <div class="py-1">
                    <button
                        type="button"
                        class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        @click="exportData('csv')"
                    >
                        Export as CSV
                    </button>
                    <button
                        type="button"
                        class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        @click="exportData('xlsx')"
                    >
                        Export as Excel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WhatsappUsersExportButton',

    props: {
        hasUsers: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showExportMenu: false,
            sortColumn: 'joined_whats_app_community_at',
            sortDirection: 'desc',
        };
    },

    mounted() {
        // Listen for sort changes from the table component
        if (this.$root) {
            this.$root.$on('whatsapp-users-sort-changed', this.handleSortChanged);
        }
    },

    beforeDestroy() {
        // Clean up event listener
        if (this.$root) {
            this.$root.$off('whatsapp-users-sort-changed', this.handleSortChanged);
        }
    },

    methods: {
        handleSortChanged(sortData) {
            this.sortColumn = sortData.column;
            this.sortDirection = sortData.direction;
        },
        closeExportMenu() {
            this.showExportMenu = false;
        },
        exportData(format) {
            this.showExportMenu = false;
            
            // Build export URL with current sort parameters
            const params = new URLSearchParams({
                format: format,
                sort_column: this.sortColumn,
                sort_direction: this.sortDirection,
            });
            
            const url = `/broker/admin/whatsapp-users/export?${params.toString()}`;
            
            // Create a temporary link and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>

